import { render } from "./subjectcasebook.vue?vue&type=template&id=7188c432&scoped=true"
import script from "./subjectcasebook.js?vue&type=script&lang=js"
export * from "./subjectcasebook.js?vue&type=script&lang=js"

import "./subjectcasebook.vue?vue&type=style&index=0&id=7188c432&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7188c432"]])

export default __exports__